import { useEffect, useState } from 'react'

/**
 * Hook that returns a boolean indicating whether the current viewport matches the provided media query.
 *
 * @param query - The media query string to evaluate.
 * @returns A boolean indicating whether the media query matches the current viewport.
 */
export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query)
    setMatches(mediaQueryList.matches)

    const handleMediaQueryListChange = (
      mediaQueryListEvent: MediaQueryListEvent
    ) => {
      setMatches(mediaQueryListEvent.matches)
    }
    mediaQueryList.addEventListener('change', handleMediaQueryListChange)

    return () => {
      mediaQueryList.removeEventListener('change', handleMediaQueryListChange)
    }
  }, [query])

  return matches
}
